import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { RouteConstants } from 'src/assets/constants/route';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit{
  isLoginScreen:boolean = false;
  isLandingScreen:boolean = false;

  startY: any;
  isPulling: boolean = false;
  isPullingAllowed: boolean = false;
  showScrollLoader: boolean = false;

  onTouchStart(event: TouchEvent): void {
    this.startY = event.touches[0].clientY;
    this.isPulling = false;
    this.isPullingAllowed = document.querySelector('#landing-page-scroll')?.scrollTop === 0;
  }

  onTouchMove(event: TouchEvent): void {
    if (event.touches[0].clientY - this.startY >= 50 && this.isPullingAllowed) {
    this.showScrollLoader = true;
    }
    if (event.touches[0].clientY - this.startY >= 100 && this.isPullingAllowed) {
      this.isPulling = true;
      event.preventDefault();

    } else {
      this.isPulling = false;
    }
    if (event.touches[0].clientY - this.startY <= 5)
      this.showScrollLoader = false;

  }
  
  onTouchEnd(): void {
    if (this.isPulling) {
      this.refreshContent();
    }
    this.isPullingAllowed = false;
    this.showScrollLoader = false;
  }

  refreshContent(): void {
    location.reload();
    setTimeout(() => {
      this.isPulling = false;
      location.reload();
    }, 1000);
  }



  constructor(public router:Router, public util:UtilService){
    this.router.events.subscribe((val) => {
      if ((this.router.url == RouteConstants.routes.login ||this.router.url == RouteConstants.routes.emailVerification) && !this.util.isMobile ) {
        this.isLoginScreen = true
      }
      else {
        this.isLoginScreen = false;
      }

      if((this.router.url === RouteConstants.routes.main || this.router.url === RouteConstants.routes.home || this.router.url === RouteConstants.routes.homeNew) && !this.util.isMobile){
        this.isLandingScreen = true;
      }else{
        this.isLandingScreen = false;
      }


    });
  }

  ngOnInit(): void {

  }


}
